import Landing from "../../components/Landing";

export default function LandingPage() {
  return (
    <>
      <Landing />
    </>
  );
}
